// Vendors
import $ from 'jquery';

$(function () {
  const $searchToggleButton = $('#mobile-search-toggle');
  const $mobileSearchOverlay = $('.mobile-nav__search');
  const $mobileNav = $('.mobile-nav');
  const $mobileSections = $('.mobile-nav__sections');
  const $mobileHamburger = $('[data-toggle="nav-mobile"]');
  const $mobileHeader = $('.mobile-header');
  const currentUrl = window.location.href;
  let searchActive = false;

  // Returns the current bottom of the fixed header bar (accounts for minimized state)
  const getHeaderBottom = () => $('.mobile-header__top')[0].getBoundingClientRect().bottom;

  // Minimize header on scroll
  window.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
      $mobileHeader.addClass('mobile-header--minimized');
    } else {
      $mobileHeader.removeClass('mobile-header--minimized');
    }
  });

  // Toggle mobile nav open / closed
  $mobileHamburger.on('click', (event) => {
    event.preventDefault();

    // If search is open, close it first
    if (searchActive) {
      closeSearch();
    }

    if ($mobileHamburger.hasClass('hamburger--active')) {
      closeNav();
    } else {
      openNav();
    }
  });

  // Toggle nested submenu items
  $('.mobile-nav__primary').on('click', 'i', (event) => {
    event.preventDefault();
    const $link = $(event.currentTarget).closest('a');
    const $subMenu = $link.siblings('.sub-menu');

    if (!$subMenu.hasClass('sub-menu--visible')) {
      $subMenu.addClass('sub-menu--visible');
      $link.addClass('caret--up');
    } else {
      $subMenu.removeClass('sub-menu--visible');
      $link.removeClass('caret--up');
    }
  });

  // Toggle search overlay
  if ($searchToggleButton.length) {
    $searchToggleButton.on('click', () => {
      if (!searchActive) {
        openSearch();
      } else {
        closeSearch();
      }
    });
  }

  // Close search when clicking the dark overlay background
  $mobileSearchOverlay.on('click', (event) => {
    if (event.target !== event.currentTarget) return;
    closeSearch();
  });

  // --------------------------------------------------
  // helpers
  // --------------------------------------------------

  const openNav = () => {
    $mobileHamburger.addClass('hamburger--active');
    $mobileNav.addClass('mobile-nav--visible').animate({ top: getHeaderBottom() }, 100, 'linear');
    $('body').addClass('nav-mobile-is-visible');
    $('html').addClass('nav-mobile-is-visible');
    openCurrentPageSubmenu();
  };

  const closeNav = () => {
    $mobileHamburger.removeClass('hamburger--active');
    $mobileNav.removeClass('mobile-nav--visible').animate({ top: '150%' }, 100, 'linear');
    $('body').removeClass('nav-mobile-is-visible');
    $('html').removeClass('nav-mobile-is-visible');
  };

  const openSearch = () => {
    searchActive = true;
    $mobileSections.hide();
    $mobileSearchOverlay.fadeIn(200).css('display', 'flex');

    // If nav isn't open yet, open it to show the search overlay
    if (!$mobileNav.hasClass('mobile-nav--visible')) {
      $mobileNav.addClass('mobile-nav--visible').animate({ top: getHeaderBottom() }, 100, 'linear');
      $('body').addClass('nav-mobile-is-visible');
      $('html').addClass('nav-mobile-is-visible');
    }
  };

  const closeSearch = () => {
    searchActive = false;
    $mobileSearchOverlay.fadeOut(300, () => {
      $mobileSections.show();
    });

    // If nav was opened only for search, close it
    if (!$mobileHamburger.hasClass('hamburger--active')) {
      setTimeout(() => {
        $mobileNav.removeClass('mobile-nav--visible').animate({ top: '150%' }, 100, 'linear');
        $('body').removeClass('nav-mobile-is-visible');
        $('html').removeClass('nav-mobile-is-visible');
      }, 150);
    }
  };

  const openCurrentPageSubmenu = () => {
    const mobileNavEl = document.getElementById('menu-mobile-navigation');
    if (!mobileNavEl) return;

    for (const listItem of mobileNavEl.children) {
      if ([...listItem.classList].includes('current-page-parent')) {
        const link = listItem.querySelector('a');
        const subMenu = listItem.querySelector('ul');
        if (link) link.classList.add('caret--up');
        if (subMenu) subMenu.classList.add('sub-menu--visible');
        break;
      }
    }
  };

  // Current Issue Nav Item — insert at position 3 in the list
  if ($('.mobile-nav__current-issue').length) {
    const $currentIssueLink = $('.mobile-nav__current-issue');
    const currentIssueHref = $currentIssueLink.find('a').attr('href');

    if (currentIssueHref === currentUrl) {
      $currentIssueLink.addClass('current-menu-item');
    }

    const currIssueItem = document.querySelector('.mobile-nav__current-issue');
    const mobileNavList = currIssueItem.previousElementSibling;

    if (mobileNavList) {
      mobileNavList.insertBefore(
        currIssueItem,
        mobileNavList.getElementsByTagName('li')[2]
      );
    }
  }
});
